import { Capacity } from './../../shared/models/capacity.model';
import produce from 'immer';
import * as fromActions from './capacity.actions';
import { IOverrideCapacity } from '@signal/asp-data-commons/lib/interfaces/availability';

export interface CapacityState {
    capacity: Capacity[],
    capacityOverride: IOverrideCapacity,
    capacitySelectedDate: string | null,
    loading: boolean,
    loaded: boolean,
    error: string
}

const initialState: CapacityState = {
    capacity: [],
    capacityOverride: {} as IOverrideCapacity,
    capacitySelectedDate: null,
    loading: false,
    loaded: false,
    error: ''
};

export function capacityReducer(state: CapacityState = initialState,
    action: fromActions.CapacityActions): CapacityState {

    switch (action.type) {
        case fromActions.CapacityActionTypes.LOAD_CAPACITY: {
            return produce(state, draftState => {
                draftState.capacity = [];
                draftState.capacitySelectedDate = null;
                draftState.loaded = false;
                draftState.loading = true;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.LOAD_CAPACITY_SUCCESS: {
            return produce(state, draftState => {
                draftState.capacity = action instanceof fromActions.LoadCapacitySuccess ? action.payload.capacity : [];
                draftState.loaded = true;
                draftState.capacitySelectedDate = null;
                draftState.loading = false;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.LOAD_CAPACITY_FAILURE: {
            return produce(state, draftState => {
                draftState.capacity = [];
                draftState.capacitySelectedDate = null;
                draftState.loaded = true;
                draftState.loading = false;
                draftState.error = action instanceof fromActions.LoadCapacityFailure ? action.payload.error : '';
            });
        }
        case fromActions.CapacityActionTypes.LOAD_CAPACITY_FOR_DATE: {
            return produce(state, draftState => {
                draftState.capacity = state.capacity;
                draftState.capacitySelectedDate = action instanceof fromActions.LoadCapacityForDate ? action.payload : null;
                draftState.loaded = false;
                draftState.loading = true;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.LOAD_CAPACITY_FOR_DATE_SUCCESS: {
            return produce(state, draftState => {
                draftState.capacitySelectedDate = action instanceof fromActions.LoadCapacityForDateSuccess ? action.payload : null;
                draftState.loaded = true;
                draftState.capacity = state.capacity;
                draftState.loading = false;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.LOAD_CAPACITY_FOR_DATE_FAILURE: {
            return produce(state, draftState => {
                draftState.capacitySelectedDate = null;
                draftState.loaded = true;
                draftState.capacity = state.capacity;
                draftState.loading = false;
                draftState.error = action instanceof fromActions.LoadCapacityForDateFailure ? action.payload.error : '';
            });
        }
        case fromActions.CapacityActionTypes.UPDATE_CAPACITY: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateCapacity ? action.payload : null;
                draftState.capacitySelectedDate = action instanceof fromActions.UpdateCapacity ? action.payload.date : null;
                draftState.loaded = false;
                draftState.capacity[payload.date] = payload;
                draftState.loading = true;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.UPDATE_CAPACITY_SUCCESS: {
            return produce(state, draftState => {
                draftState.capacitySelectedDate = action instanceof fromActions.UpdateCapacitySuccess ? action.payload.date : null;
                draftState.loaded = true;
                draftState.capacity = state.capacity;
                draftState.loading = false;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.UPDATE_CAPACITY_FAILURE: {
            return produce(state, draftState => {
                draftState.capacitySelectedDate = null;
                draftState.loaded = true;
                draftState.capacity = state.capacity;
                draftState.loading = false;
                draftState.error = action instanceof fromActions.UpdateCapacityFailure ? action.payload.error : '';
            });
        }
        case fromActions.CapacityActionTypes.LOAD_CAPACITY_OVERRIDE_FOR_DATE: {
            return produce(state, draftState => {
                draftState.capacity = state.capacity;
                draftState.capacityOverride = {} as IOverrideCapacity;
                draftState.capacitySelectedDate = action instanceof fromActions.LoadCapacityOverrideForDate ? action.payload : null;
                draftState.loaded = false;
                draftState.loading = true;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.LOAD_CAPACITY_OVERRIDE_FOR_DATE_SUCCESS: {
            return produce(state, draftState => {
                draftState.capacitySelectedDate = state.capacitySelectedDate;
                draftState.loaded = true;
                draftState.capacity = state.capacity;
                draftState.capacityOverride = action instanceof fromActions.LoadCapacityOverrideForDateSuccess ? action.payload : null;
                draftState.loading = false;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.LOAD_CAPACITY_OVERRIDE_FOR_DATE_FAILURE: {
            return produce(state, draftState => {
                draftState.capacitySelectedDate = null;
                draftState.loaded = true;
                draftState.capacity = state.capacity;
                draftState.loading = false;
                draftState.error = action instanceof fromActions.LoadCapacityOverrideForDateFailure ? action.payload.error : '';
            });
        }
        case fromActions.CapacityActionTypes.UPDATE_CAPACITY_OVERRIDE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateCapacityOverride ? action.payload : null;
                draftState.capacitySelectedDate = action instanceof fromActions.UpdateCapacityOverride ? action.payload.date : null;
                draftState.loaded = false;
                draftState.capacityOverride = payload;
                draftState.loading = true;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.UPDATE_CAPACITY_OVERRIDE_SUCCESS: {
            return produce(state, draftState => {
                draftState.capacitySelectedDate = action instanceof fromActions.UpdateCapacityOverrideSuccess ? action.payload.date : null;
                draftState.loaded = true;
                draftState.capacityOverride = state.capacityOverride;
                draftState.loading = false;
                draftState.error = '';
            });
        }
        case fromActions.CapacityActionTypes.UPDATE_CAPACITY_OVERRIDE_FAILURE: {
            return produce(state, draftState => {
                draftState.capacitySelectedDate = null;
                draftState.loaded = true;
                draftState.capacity = state.capacity;
                draftState.loading = false;
                draftState.error = action instanceof fromActions.UpdateCapacityOverrideFailure ? action.payload.error : '';
            });
        }
        default:
            return state;
    }
}